import * as OM from '@/model';
import * as VM from '@/viewmodel';

class _StorageServices {
    // Chiavi di localStorage usate da questa classe
    private static readonly KEYS = {
        userIdentifier: 'userIdentifier',
        locale: 'locale',
        opPrefix: '_op_',
        loginData: '_loginData',
        villageConfig: '_VillageConfig',
        showSaldo: 'showSaldo',
        lastPositionTime: 'lastPositionTime',
        lastVisitedAreaSoci: 'LastVisitedAreaSoci',
        referralCode: 'ReferralCode',
    };

    // 🔹 Helpers privati
    private readFromLocalStorage<T>(lsName: string): T | null {
        const data = window.localStorage.getItem(lsName);
        if(data == 'undefined')
            return null;
        
        return !!data ? JSON.parse(data) as T : null;
    }

    private writeToLocalStorage<T>(lsName: string, value: T) {
        window.localStorage.setItem(lsName, JSON.stringify(value));
    }

    // 🔹 Metodo per pulire solo le chiavi di competenza
    clearData() {
        const { KEYS } = _StorageServices;

        // Rimuove le chiavi fisse
        Object.values(KEYS)
            .filter(k => k !== KEYS.opPrefix)
            .forEach(k => window.localStorage.removeItem(k));

        // Rimuove tutte le chiavi che iniziano con _op_
        Object.keys(window.localStorage)
            .filter(k => k.startsWith(KEYS.opPrefix))
            .forEach(k => window.localStorage.removeItem(k));
    }

    // 🔹 Getter & Setter

    getUserIdentifier() {
        return this.readFromLocalStorage<string>(_StorageServices.KEYS.userIdentifier);
    }
    setUserIdentifier(value: string) {
        this.writeToLocalStorage(_StorageServices.KEYS.userIdentifier, value);
    }

    SetLanguage(language: string) {
        window.localStorage.setItem(_StorageServices.KEYS.locale, language);
    }
    GetLanguage() {
        return window.localStorage.getItem(_StorageServices.KEYS.locale) || '';
    }

    setOpTableFilters(key: string, filters: any) {
        this.writeToLocalStorage(_StorageServices.KEYS.opPrefix + key, filters);
    }
    getOpTableFilters(key: string) {
        return this.readFromLocalStorage<any>(_StorageServices.KEYS.opPrefix + key);
    }

    setLoginData(loginData: OM.LoginData) {
        this.writeToLocalStorage(_StorageServices.KEYS.loginData, loginData);
    }
    getLoginData() {
        return this.readFromLocalStorage<OM.LoginData>(_StorageServices.KEYS.loginData);
    }

    setVillageConfig(VillageConfig: OM.VillageConfig) {
        this.writeToLocalStorage(_StorageServices.KEYS.villageConfig, VillageConfig);
    }
    getVillageConfig() {
        return this.readFromLocalStorage<OM.VillageConfig>(_StorageServices.KEYS.villageConfig);
    }

    setShowSaldo(value: boolean) {
        this.writeToLocalStorage(_StorageServices.KEYS.showSaldo, value);
    }
    getShowSaldo() {
        return this.readFromLocalStorage<boolean>(_StorageServices.KEYS.showSaldo);
    }

    setLastPositionTime(value: string) {
        this.writeToLocalStorage(_StorageServices.KEYS.lastPositionTime, value);
    }
    getLastPositionTime() {
        return this.readFromLocalStorage<string>(_StorageServices.KEYS.lastPositionTime);
    }

    setLastVisitedAreaSoci(value: boolean) {
        this.writeToLocalStorage(_StorageServices.KEYS.lastVisitedAreaSoci, value);
    }
    getLastVisitedAreaSoci() {
        return this.readFromLocalStorage<boolean>(_StorageServices.KEYS.lastVisitedAreaSoci);
    }

    setReferralCode(value: string) {
        this.writeToLocalStorage(_StorageServices.KEYS.referralCode, value);
    }
    getReferralCode() {
        return this.readFromLocalStorage<string>(_StorageServices.KEYS.referralCode);
    }
}

export let StorageServices = new _StorageServices();